/** Метод в отличии от isEmpty из lodash проверяет не только коллекции */
export const isEmpty = (value: any) => {
  if (Array.isArray(value)) {
    return !value.length
  }

  if (value === null) {
    return true
  }

  if (typeof value === 'object') {
    return !Object.keys(value).length
  }

  return !value
}
